import { formatDate } from '@angular/common';
import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { TranslateService } from '@ngx-translate/core';

export const getReportsDataTableStructure = (translate: TranslateService): DynamicDataTable => {
  const dacReferenceColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.table.dac_reference',
    accessorKey: 'dacReference',
    variant: DataTableColumnVariant.TEXT,
  };

  const realisationEnvisageesColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.table.realisation_envisagees',
    accessorKey: 'realisationEnvisagees',
    variant: DataTableColumnVariant.TEXT,
  };

  const dateLimiteSoumissionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.table.date_limite_soumission',
    accessorKey: 'dateLimiteSoumission',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? formatDate(value, 'dd/MM/yyyy HH:mm', 'en-US') : '-',
      };
    },
  };

  const demandesCountColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.table.demandes_count',
    accessorKey: 'demandes',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: any[]) => {
      return {
        value: value ? value.length.toString() : '0',
      };
    },
  };

  return {
    singular: 'clarification.reports.singular',
    plural: 'clarification.reports.plural',
    columns: [dacReferenceColumn, realisationEnvisageesColumn, dateLimiteSoumissionColumn, demandesCountColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['dacReference', 'realisationEnvisagees'],
  };
};
